import { createReducer } from '@reduxjs/toolkit';
import { GroupSetsStoreState } from '@Types/groupSets.types';
import {
  listGroupSets,
  listGroupSetsResolved,
  listGroupSetsRejected,
} from '@Actions/groupSets.actions';
import { normalizeGroupSetAssetType } from '@Utils/groupSetUtils';

export const initState: GroupSetsStoreState = {
  isLoading: false,
  status: null,
  groupSetsList: [],
  groupSet: {
    isLoading: false,
    groupSet: null,
  },
};

export const groupSetsReducer = createReducer(initState, builder => {
  builder
    .addCase(listGroupSets, state => {
      state.isLoading = true;
      state.status = null;
    })
    .addCase(listGroupSetsResolved, (state, action) => {
      state.groupSetsList = action.payload.map(groupSet => ({
        ...groupSet,
        assetType: normalizeGroupSetAssetType(groupSet),
      }));
      state.isLoading = false;
      state.status = 'success';
    })
    .addCase(listGroupSetsRejected, (state, action) => {
      state.isLoading = false;
      state.status = action.payload.text || 'error';
      state.groupSetsList = [];
    });
});

export default groupSetsReducer;
